import { ThemeProvider } from '@emotion/react';
import Close from '@mui/icons-material/Close';
import { Grid, TextField } from '@mui/material';
// import Autocomplete from '@mui/material/Autocomplete';
import IconButton from '@mui/material/IconButton';
import Paper from '@mui/material/Paper';
import { createTheme } from '@mui/material/styles';
import { withStyles } from '@mui/styles';
import { searchedBackstages } from 'APIs/BackstageApi';
import { searchedUsers } from 'APIs/UserDataApi';
import { useAppSelector } from 'app/hooks';
import { selectNft } from 'features/auth/nftSlice';
import Backstage from 'interfaces/Backstage.interface';
import NftData from 'interfaces/NftData.interface';
import { UserData } from 'interfaces/UserData.interface';
import { useEffect, useRef, useState } from 'react';
import Results from './Results';
import './styles.css';

const colortheme = createTheme({
  palette: {
    error: {
      main: '#c1c1c1',
    },
    primary: {
      main: '#292739',
    },
    secondary: {
      main: '#c1c1c1',
    },
  },
  typography: {
    fontFamily: ['lato'].join(','),
  },
});

const WhiteTextField = withStyles({
  root: {
    '& .MuiInputBase-input': {
      color: '#fff', // Text color
      fontSize: '14px',
      border: 'none',
    },
  },
})(TextField);

// const UserAutoComplete = withStyles({
//   root: {
//     width: '100%',
//     height: '100%',

//     '& .auto-complete-cont': {
//       background: '#000',
//     },
//     '& .MuiOutlinedInput-root': {
//       height: '100%',
//       '& .MuiInputBase-root': {
//         paddingRight: '0px',
//       },
//     },
//     '&.MuiAutocomplete-hasPopupIcon .MuiFormControl-root .MuiOutlinedInput-root.MuiInputBase-root':
//       {
//         paddingRight: '0px',
//       },
//     '& .MuiFormControl-root .MuiOutlinedInput-root': {
//       padding: '0px',
//       '& .MuiOutlinedInput-notchedOutline': {
//         border: 'none',
//       },
//       '& .MuiAutocomplete-endAdornment': {
//         display: 'none',
//       },
//     },
//     '& .MuiAutocomplete-popper': {
//       background: '#000000',
//     },
//   },
// })(Autocomplete);

interface IHeaderSearchInputProps {
  mobile?: boolean;
}

const HeaderSearchInput = ({ mobile }: IHeaderSearchInputProps) => {
  const searchIcon = require('assets/icons/searchIcon.svg');
  const [input, setInput] = useState<string>('');
  const [loading, setLoading] = useState<boolean>(false);
  const [close, setClose] = useState(true);
  const [users, setUsers] = useState<UserData[]>([]);
  const [posts, setPosts] = useState<Backstage[]>([]);
  const [nfts, setNfts] = useState<NftData[]>([]);
  const renderOnce = useRef(false);
  const nftState = useAppSelector(selectNft);

  useEffect(() => {
    if (renderOnce.current && input !== '') {
      setLoading(true);
      const delayDebounceFn = setTimeout(async () => {
        const queryUsers = await searchedUsers(input);
        const queryPosts = await searchedBackstages(input);

        setUsers(queryUsers.data);
        setPosts(queryPosts.data);
        setNfts(
          nftState.nfts
            ? nftState.nfts.filter(nft => nft.title.includes(input)).slice(0, 3)
            : []
        );
        setLoading(false);
      }, 3000);
      return () => clearTimeout(delayDebounceFn);
    } else {
      renderOnce.current = true;
      setLoading(false);
      setPosts([]);
      setUsers([]);
      setNfts([]);
    }
  }, [input, nftState.nfts]);

  const handleClose = () => {
    setInput('');
    setClose(true);
  };

  return (
    <ThemeProvider theme={colortheme}>
      <Grid sx={{ position: 'relative' }}>
        <Paper
          component="form"
          sx={{
            display: 'flex',
            alignItems: 'center',
            width: mobile ? '90%' : '100%',
            height: mobile ? '35px' : '55px',
            paddingRight: '12px',
            backgroundColor: 'rgba(255,255,255,0.16862745098039217 )',
            borderRadius: '20px',
          }}
        >
          <IconButton
            type="submit"
            sx={{ color: '#c1c1c1', padding: '10px' }}
            aria-label="search"
          >
            <img
              src={searchIcon.default}
              alt="icon"
              style={{
                height: mobile ? '15px' : '25px',
                maxWidth: mobile ? '15px' : '25px',
              }}
            />
            {/* <SearchIcon style={{ fontSize: "30px" }} /> */}
          </IconButton>

          <WhiteTextField
            id="textfield-search"
            onFocus={() => setClose(false)}
            onChange={e => setInput(e.target.value)}
            value={input}
            onKeyDown={e => e.keyCode === 13 && e.preventDefault()}
            sx={{
              ml: 1,
              flex: 1,
              color: '#ffffff',
              height: '55px',
              padding: 'unset',
              margin: 'unset',
              fontSize: '14px',
              '& fieldset': { border: 'none' },
            }}
            placeholder="Search"
          />
          {!close && (
            <IconButton onClick={handleClose} size="small">
              <span
                style={{ color: 'white', fontSize: '12px', marginRight: '5px' }}
              >
                Clear
              </span>
              <Close sx={{ fontSize: '1.1rem', color: 'white' }} />
            </IconButton>
          )}
        </Paper>

        {!close && (
          <Results posts={posts} users={users} nfts={nfts} loading={loading} />
        )}
      </Grid>
    </ThemeProvider>
  );
};

export default HeaderSearchInput;
